import axios from "axios";
import swal from "sweetalert";
// import { useNavigate } from "react-router-dom";

// import React from "react";

// const BASE_URL = "http://localhost:8001/api/v1/";
const BASE_URL = "https://api.resipro.in/api/v1/"

//common services
//post method
export async function makePostRequest(endpoint, bodyFormData) {
  // console.log("Access Token " + sessionStorage.getItem("accessToken"));

  return axios({
    method: "post",
    url: BASE_URL + endpoint,

    data: bodyFormData,
    headers: {
      "Content-Type": "application/json",
      typelogin: "societyManagement",
      Authorization: `Bearer ${sessionStorage.getItem(
        "accessToken"
      )} ${sessionStorage.getItem("schema")}`,
      "Access-Control-Allow-Origin": "*",
      // "token":localStorage.getItem('token')
    },
  }).catch(function (error) {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/login";
      return;
    }
    let errMsg = error.response.data.message;
    return Promise.reject(errMsg);

  });
}

export async function uploadFileRequest(endpoint, bodyFormData) {
  return axios({
    method: "post",
    url: BASE_URL + endpoint,

    data: bodyFormData,
    headers: {
      "Content-Type": "multipart/form-data",
      typelogin: "societyManagement",
      Authorization: `Bearer ${sessionStorage.getItem(
        "accessToken"
      )} ${sessionStorage.getItem("schema")}`,
      "Access-Control-Allow-Origin": "*",
    },
  }).catch(function (error) {
    // let errMsg = error.response.data.message;
    console.log(error);
    if (error.response.StatusCode === 404) {
      swal("UnAuthorized User Please Login Again", "", "warning", {
        timer: 3000,
        buttons: false,
      });
      localStorage.clear();
      sessionStorage.clear();
      window.location = "/";
    } else if (error.response.StatusCode === 401) {
      swal("Session Expired " + "Please Login Again", "", "warning", {
        timer: 3000,
        buttons: false,
      });
      localStorage.clear();
      sessionStorage.clear();
      window.location = "/";
    }
    // else if (error.response.StatusCode == 400) {
    //   swal("Invalid Data " + errMsg, "", "warning", {
    //     timer: 2000,
    //     buttons: true,
    //   });
    //   // localStorage.clear();
    //   // sessionStorage.clear();
    //   // window.location = '/';
    // }
    // else {
    //   swal(" " + errMsg, "", "warning", {
    //     timer: 2000,
    //     buttons: false,
    //   });
    // }
  });
}

// get method
export async function makeGetRequest(endpoint, bodyFormData) {
  return axios({
    method: "get",
    url: BASE_URL + endpoint,

    data: bodyFormData,
    headers: {
      "Content-Type": "application/json",
      typelogin: "societyManagement",
      Authorization: `Bearer ${sessionStorage.getItem(
        "accessToken"
      )} ${sessionStorage.getItem("schema")}`,
      "Access-Control-Allow-Origin": "*",
    },
  }).catch(function (error) {
    // let errMsg = error.response.data.message;

    console.log(error.response.status);
    if (error.response.status === 404) {
      swal("UnAuthorized User Please Login Again", "", "warning", {
        timer: 2000,
        buttons: false,
      });
      localStorage.clear();
      sessionStorage.clear();
      window.location = "/";
    } else if (error.response.status === 401) {
      swal("Session Expired Please Login Again", "", "warning", {
        timer: 3000,
        buttons: false,
      });
      // swal("warning " + errMsg, "", "warning", {
      //   timer: 3000,
      //   buttons: false,
      // });
      localStorage.clear();
      sessionStorage.clear();
      window.location = "/";
    }
    // else if (error.response.status == 400) {
    //   swal("Invalid Data " + errMsg, "", "warning", {
    //     timer: 2000,
    //     buttons: true,
    //   });
    //   // localStorage.clear();
    //   // sessionStorage.clear();
    //   // window.location = '/';
    // }
    // else {
    //   swal(" " + errMsg, "", "warning", {
    //     timer: 2000,
    //     buttons: false,
    //   });
    // }
  });
}

// //put method
// export function makeFormData(fields, data) {
//   console.assert(
//     fields.length === data.length,
//     "Length of Fields and Data must be equal"
//   );
//   let bodyFormData = new FormData();
//   fields.forEach((_, index) => {
//     bodyFormData.append(fields[index], data[index]);
//   });
//   return bodyFormData;
// }

// export async function makePutRequest(endpoint, bodyFormData) {
//   return axios({
//     method: "put",
//     url: BASE_URL + endpoint,

//     data: bodyFormData,
//     headers: {
//       "Content-Type": "application/json",
//       typelogin: localStorage.getItem("logintypefornotitefy"),
//       Authorization: `Bearer ${localStorage.getItem("token_id")}`,
//       //"Access-Control-Allow-Origin": "*",
//     },
//   }).catch(function (error) {
//     let errMsg = error.response.data.message;
//     swal(" " + errMsg, "", "warning", {
//       timer: 2000,
//       buttons: false,
//     });

//     localStorage.clear();
//     sessionStorage.clear();
//     window.location = "/";
//   });
// }
